export const AUTH_QUERY_MAX_ATTEMPTS = 3;
export const AUTH_QUERY_RETRY_DELAY_MS = 1000;

export function shouldRetryAuthQuery(failureCount: number) {
  return failureCount < AUTH_QUERY_MAX_ATTEMPTS;
}
